export default "__VITE_ASSET__D$juG$iA__"